import React from "react";
import { Link } from "react-router-dom";
import logo from "assets/images/logo.png";
import back from "assets/images/back.svg";

const FormHeader = ({ stepIndex, handleBack, stepsLength }) => (
  <header className="lead_page__header">
    <div className="back-button-wrapper back-header">
      {stepIndex !== stepsLength - 1 && stepIndex > 0 && (
        <img
          src={back}
          alt="Back Icon"
          className="back-icon"
          onClick={handleBack}
        />
      )}
    </div>

    {/* Wrap logo with Link to route on click */}
    <Link to="/">
      <img src={logo} alt="Fullman Firm Logo" className="logo" />
    </Link>
  </header>
);

export default FormHeader;
